<script lang="ts">
	import '$lib/styles/app.css';
	import Footer from './Footer/Footer.svelte';
	import Head from './Head/Head.svelte';
	import Navbar from './Navbar/Navbar.svelte';
	import type { LayoutData } from './$types';
	import { browser, dev } from '$app/environment';
	import { defaultLocale } from '$lib/i18n';
	import { getCmsTranslationForLocale } from '$lib/cms';
	import { isMobile, modalIsOpen } from '$lib/stores';
	import { locale } from 'svelte-i18n';
	import { onMount } from 'svelte';

	export let data: LayoutData;

	if (browser && !dev) {
		import('$lib/logging/client-logger');
	}

	onMount(() => {
		window.document.documentElement.setAttribute('lang', $locale || defaultLocale);
	});

	// Workaround for the navbar/burger menu not being natively responsive
	let viewportWidth = 1200;
	$: $isMobile = (viewportWidth || 0) <= 1199;

	$: configTranslation = getCmsTranslationForLocale(data.pageConfig.translations, $locale);
</script>

<svelte:window bind:innerWidth={viewportWidth} />

<Head
	gtmId={data.pageConfig.google_tag_manager_id}
	qualtricsContainerId={data.pageConfig.qualtrics_container_id}
	metaDescription={configTranslation.meta_description}
/>

<div class="wrap">
	<Navbar
		mainNav={data.mainNav}
		worlds={data.worlds}
		languages={data.languages}
		headerNotificationMessage={configTranslation.header_notification_message}
	/>

	<main class="main">
		<div class="container">
			<slot />
		</div>
	</main>

	<Footer footer={data.footer} />

	{#if $modalIsOpen}
		<div class="modal-backdrop fade show" />
	{/if}
</div>

<style>
	.wrap {
		height: 100vh;
	}

	.container {
		padding-top: 2rem;
	}

	main.main {
		margin-top: 5rem;
	}
</style>
